<template>
	<div class="container">
		<div class="section-wrapper top-wrapper">
			<!-- <div>
				<mt-field class="input-wrapper" v-model="member_company" placeholder="Company name" type="text" />
			</div> -->
			<div >
				<mt-field class="input-wrapper" v-model="member_truename" placeholder="Full name" type="text" />
			</div>
			<div >
				<mt-field class="input-wrapper" v-model="member_email" placeholder="Email address" type="text" />
			</div>
			<div >
				<mt-field class="input-wrapper" v-model="area_code" placeholder="Tel country code" type="text" />
			</div>
			<div >
				<mt-field class="input-wrapper" v-model="telphone" placeholder="Mobile number" type="number"/>
			</div>
			<div>
				<mt-field  class="input-wrapper" v-model="captcha_normal" placeholder="Verification Code" maxlength="6">
                    <img @click="changePictureCode" :src="pictureCodeUrl" class="countdown" >
                </mt-field>
			</div>
			<div>
				<div class="mint-cell-wrapper congjiao">	
				<select v-model="country">
    				<option value="">Please select country</option>
    				<option v-for="(item, index) in countrylists" :value="item.countryname">{{item.countryname}}</option>
    			</select>
				</div>
				
			</div>
		</div>
		<div class="section-wrapper bottom-wrapper">
			<div >
				<mt-field
					type="password"
					class="input-wrapper"
					v-model="member_password"
					placeholder="Password"
					maxlength="20"
				/>
			</div>
			<div >
				<mt-field
					type="password"
					class="input-wrapper"
					v-model="member_password_confirm"
					placeholder="Confirm Password"
					maxlength="20"
				/>
			</div>
		</div>
		<label class="tips">6-20 digits of numbers / letters / symbols</label>
		<label class="agreement">
			<input type="checkbox" name="onAgreements" id="onAgreements"/>
			By creating an account, you agree to DYP Mall<span class="right-text" @click="onAgreement">《User Registration Agreement》</span>
		</label>

		<mt-button class="ds-button-large mt-10 mb-10" type="primary" v-on:click="onSubmit">register</mt-button>
		<!--<div class="link-wrapper">
			<span class="left-text">点击注册表示同意</span>
			<span class="right-text" @click="onAgreement">《DYP Mall's Conditions of Use and Privacy Notice》</span>
		</div>-->
	</div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import { registerByMobile } from '../../../api/memberRegister'
import { getSmsCaptcha } from '../../../api/common'
export default {
  name: 'RegisterByMobile',
  data () {
    return {
    	member_company:'',
    	member_truename:'',
    	pictureCodeUrl: '',
    	member_email:'',
      username: '',
      area_code:'',
      captcha_normal:'',
      country:'',
      telphone:'',
      code: '',
      countrylists:'',
      member_password: '',
      member_password_confirm: '',
      aggrementUrl: '',
      verifyCodeMobile: '',
      canSendMobile: true,
      timeIntervalMobile: false,
      sendStateTextMobile: '发送'
    }
  },
  mounted () {
    
  },
  created: function () {
  	let country = require('../../../api/country.json')
	this.countrylists=country;
	this.changePictureCode();
  },
  computed: {
    ...mapState({
      inviter_id: state => state.member.inviterId
    })
  },

  beforeDestroy: function () {
    clearInterval(this.timeIntervalMobile)
  },
  methods: {
    ...mapMutations({
      saveAuthInfo: 'memberLogin'
    }),
    goBack () {
      this.$router.go(-1)
    },
    goProfile () {
      this.$router.go(-2)
    },
    goProfileAdd () {
      this.$router.push({ name: 'profileAdd' })
    },

    sendVerifyCodeMobile () {

    },
    check () {
    	let member_company = this.member_company;
    	let member_truename = this.member_truename;
    	let member_email = this.member_email;
    	var regemail = /^([a-zA-Z]|[0-9])(\w|\-|\.)+@[a-zA-Z0-9-_]+\.([a-zA-Z0-9-_.]{2,10})$/;
      let code = this.code
      let password = this.member_password
      let confirmPassword = this.member_password_confirm
      var check = document.getElementById('onAgreements');
      // if (member_company.length === 0) {
      //   Toast('Please enter your company name')
      //   return false
      // }
      if (member_truename.length === 0) {
        Toast('Please enter your real name')
        return false
      }
      if (member_email.length === 0) {
        Toast('Please enter your email address')
        return false
      }else if(!regemail.test(member_email)){
    	Toast('Please enter a valid email');
		return false;
   }
      if (this.area_code.length === 0) {
        Toast('Please enter area code')
        return false
      }
      
      if (this.telphone.length === 0) {
        Toast('Please enter mobile')
        return false
      }
      if (this.captcha_normal.length === 0) {
        Toast('Please enter graphic code')
        return false
      }
      if (this.captcha_normal.length !== 4) {
        Toast('Please enter a 4-digit verification code')
        return false
      }
      
      if (this.country.length === 0) {
        Toast('Please select country')
        return false
      }
      
      if (password.length === 0) {
        Toast('Please input a password')
        return false
      }
      if (password.length < 6 || password.length > 20) {
        Toast('Please enter a password of 6-20 characters')
        return false
      }
      if (confirmPassword.length === 0) {
        Toast('Please enter the confirmation password')
        return false
      }
      if (password.length !== confirmPassword.length) {
        Toast('The confirmation password is inconsistent with the entered password')
        return false
      }
      if (password !== confirmPassword) {
        Toast('The confirmation password is inconsistent with the entered password')
        return false
      }
      if(check.checked==false){
      	Toast('Please read and agree to the user agreement')
        return false
      }
      return true
    },
    signup () {
      if (!this.check()) {
        return
      }
      Indicator.open()
      let inviterId = this.inviter_id // 获取邀请人id

      registerByMobile(this.member_company,this.member_truename,this.member_email,this.area_code,this.telphone,this.captcha_normal,this.country, this.member_password, this.member_password_confirm, inviterId).then(
        response => {
          Indicator.close()
          this.saveAuthInfo({ token: response.result.token, info: response.result.info })
          this.$router.push({ name: 'MemberIndex' })
        },
        error => {
          Indicator.close()
          Toast(error.message)
        }
      )
    },
    onSubmit () {
      this.signup()
    },
    changePictureCode () {
      this.pictureCodeUrl = env.API_HOST + '/Seccode/makecode?r=' + Math.random()
    },
    onAgreement () {
      this.$router.push({
        name: 'HomeDocument',
        query: { type: '' }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.agreement{line-height: 1.2rem;}
.congjiao{font-size: 0.7rem;padding: 0.3rem 10px;border-bottom: 1px solid #d9d9d9;}
.congjiao select{line-height: 1.5rem;display: inline-block;width: 100%;height: 1.5rem;border: none;background-color: transparent;color: #777;box-sizing: border-box;padding: 0 7px;font-size: 0.7rem;}
.agreement{font-size: 0.7rem;padding: 0 0.8rem;margin-top: 1rem;}
.agreement input{width: 0.8rem;height: 0.8rem;vertical-align: middle;}
.agreement span{color: #e93b3d;}
.container {
display: flex;
flex-direction: column;
justify-content: flex-start;
	align-items: stretch;
	//background-color: #e93b3d;
	.section-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: stretch;
		background-color: #ffffff;
		border-top: 1px solid #e8eaed;
		border-bottom: 1px solid #e8eaed;
		.input-wrapper {
			font-size: .7rem;
			display: flex;
			flex-direction: row;
			align-content: flex-start;
			align-items: center;
			background-color: #fff;
			height:2.2rem;
			padding-left:0.5rem;
			input {
				flex: 1;
			}
			.bottom-input {
				border-bottom-width: 0;
			}
			img{height:1.75rem}
		}
	}
	.link-wrapper {
		height:2.2rem;
		margin-top:0.5rem;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: stretch;
		span {
			font-size:0.7rem;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
		}
		.left-text {
			color: #c3c3c3;
		}
		.right-text {
			color: $primaryColor;
		}
	}
}
.top-wrapper {margin-top:0.5rem;}
.bottom-wrapper {margin-top:0.5rem;}
.tips {color: #c3c3c3;font-size:0.6rem;margin-left:0.9rem;margin-top:0.5rem;text-align: left;}
.countdown {min-width:4rem;margin-right:0.5rem;}
</style>
